import * as APITypes from "@/API"

import { GeneratedMutation, GeneratedQuery } from "@/types/GQLTypes"

export type GetProjectWithTaskGroupsQuery = APITypes.GetProjectQuery & {
  getProject?: { taskGroups?: { items?: { id?: string | null; name?: string | null }[] | null } | null }
}

export const getProjectWithTaskGroups = /* GraphQL */ `query GetProjectWithTaskGroups($id: ID!) {
  getProject(id: $id) {
    id
    userProfileId
    proxyId
    streamId
    stream {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    metadata
    name
    title
    aiTitle
    subtitle
    aiSubtitle
    description
    aiDescription
    aiCompletionCriteria
    userContext
    status
    state
    enabled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetProjectQueryVariables, GetProjectWithTaskGroupsQuery>

export type GetProjectWithStreamQuery = {
  getProject?: { stream?: { name?: string | null } | null }
}

export const getProjectWithStream = /* GraphQL */ `query GetProjectWithStream($id: ID!) {
  getProject(id: $id) {
    stream {
      name
    }
  }
}
` as GeneratedQuery<APITypes.GetProjectQueryVariables, GetProjectWithTaskGroupsQuery>

export type ProxyMeetingsWithSuggestedTasksByCalendarEventIdQuery = {
  proxyMeetingsByCalendarEventId?: {
    items?:
      | {
          id?: string | null
          calendarEventId?: string | null
          calendarEventICalUID?: string | null
          deduplicationKey?: string | null
          botId?: string | null
          platform?: string | null
          summaries?: string | null
          themes?: string | null
          observations?: string | null
          status?: string | null
          startTimeUtc?: string | null
          endTimeUtc?: string | null
          transcription?: {
            transcription?: {
              name?: string | null
              text?: string | null
              time?: string | null
            }[]
          }
          memories?: string | null
          sessionUID?: string | null
          aiSuggestions?: string | null
          insights?: {
            id: string
            label?: string | null
            type: string
            content?: string | null
            items?:
              | {
                  label?: string | null
                  content?: string | null
                  category?: string | null
                  completed?: boolean | null
                  items?: string[] | null
                }[]
              | null
          }
          createdAt?: string | null
          updatedAt?: string | null
          __typename?: string | null
        }[]
      | null
    nextToken?: string | null
    __typename?: string | null
  } | null
}

export const proxyMeetingsWithSuggestedTasksByCalendarEventId =
  /* GraphQL */ `query ProxyMeetingsWithSuggestedTasksByCalendarEventId(
  $calendarEventId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProxyMeetingFilterInput
  $limit: Int
  $nextToken: String
) {
  proxyMeetingsByCalendarEventId(
    calendarEventId: $calendarEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      calendarEventId
      calendarEventICalUID
      deduplicationKey
      botId
      platform
      status
      startTimeUtc
      endTimeUtc
      transcription {
        transcription {
          text
          name
          time
        }
      }
      insights {
        id
        label
        type
        content
        items {
          label
          content
          category
          completed
          items
        }
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ProxyMeetingsByCalendarEventIdQueryVariables,
    ProxyMeetingsWithSuggestedTasksByCalendarEventIdQuery
  >
export type CalendarEventsWithPreBriefByUuidQuery = {
  calendarEventsByUuid?: {
    __typename: "ModelCalendarEventConnection"
    items: Array<{
      __typename: "CalendarEvent"
      id: string
      uuid: string
      calendarId: string
      userProfileId: string
      platform: string
      proxyMeetingId?: string | null
      dateUtc: string
      projectIds?: Array<string | null> | null
      recurringId?: string | null
      iCalUid?: string | null
      title: string
      startTimeUtc?: string | null
      endTimeUtc?: string | null
      isCancelled: boolean
      shortDescription: string
      meetingUrl?: string | null
      organizerEmail?: string | null
      fullDescription?: string | null
      responseStatus?: string | null
      status?: string | null
      descriptionContentType?: string | null
      attendees?: Array<string | null> | null
      platformSpecificData: string
      metadata?: string | null
      preBrief?: Array<APITypes.InsightBlock | null> | null
      preBriefState?: string | null
      createdAt?: number | null
      updatedAt?: number | null
    } | null>
    nextToken?: string | null
  } | null
}

export const calendarEventsWithPreBriefByUuid = /* GraphQL */ `query CalendarEventsWithPreBriefByUuid(
    $uuid: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCalendarEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    calendarEventsByUuid(
      uuid: $uuid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        uuid
        calendarId
        userProfileId
        platform
        proxyMeetingId
        dateUtc
        projectIds
        recurringId
        iCalUid
        title
        location
        startTimeUtc
        endTimeUtc
        isCancelled
        shortDescription
        meetingUrl
        organizerEmail
        fullDescription
        responseStatus
        status
        descriptionContentType
        attendees
        platformSpecificData
        metadata
        preBrief {
          id
          label
          type
          content
          items {
            label
            content
            category
            completed
            items
          }
        }
        botStatus {
          statusCode
          subCode
        }
        preBriefState
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
  ` as GeneratedQuery<APITypes.CalendarEventsByUuidQueryVariables, APITypes.CalendarEventsByUuidQuery>

export const calendarEventsWithInsights = /* GraphQL */ `query CalendarEventsWithInsights(
    $userProfileId: ID!
    $startTimeUtc: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCalendarEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    calendarEventsByUserProfileIdAndStartTimeUtc(
    userProfileId: $userProfileId
    startTimeUtc: $startTimeUtc
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
      items {
        uuid
        calendarId
        userProfileId
        platform
        recurringId
        title
        startTimeUtc
        meetingUrl
        proxyMeeting {
          insights {
            id
          }
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
  ` as GeneratedQuery<APITypes.CalendarEventsByUuidQueryVariables, APITypes.CalendarEventsByUuidQuery>

export type ListEventsQuery = APITypes.CalendarEventsByUserProfileIdAndStartTimeUtcQuery & {
  items: (APITypes.CalendarEvent & { proxyMeeting: Pick<APITypes.ProxyMeeting, "summaries"> })[]
}

export const listEventsWithProxyMeeting = /* GraphQL */ `query ListEventsWithProxyMeeting(
  $userProfileId: ID!
  $startTimeUtc: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCalendarEventFilterInput
  $limit: Int
  $nextToken: String
) {
  calendarEventsByUserProfileIdAndStartTimeUtc(
    userProfileId: $userProfileId
    startTimeUtc: $startTimeUtc
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uuid
      calendarId
      userProfileId
      platform
      proxyMeetingId
      dateUtc
      projectIds
      recurringId
      title
      startTimeUtc
      endTimeUtc
      meetingUrl
      fullDescription
      responseStatus
      status
      attendees
      platformSpecificData
      proxyMeeting {
        insights {
          type
          items {
            content
          }
        }
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.CalendarEventsByUserProfileIdAndStartTimeUtcQueryVariables, ListEventsQuery>

export const updateProxyMeetingWithInsights = /* GraphQL */ `mutation UpdateProxyMeetingWithInsights(
  $input: UpdateProxyMeetingInput!
  $condition: ModelProxyMeetingConditionInput
) {
  updateProxyMeeting(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    botId
    calendarEventId
    calendarEventICalUID
    calendarId
    projectIds
    startTimeUtc
    endTimeUtc
    meetingUrl
    deduplicationKey
    meetingRawData
    platform
    summaries
    themes
    observations
    status
    transcription {
      rawTranscript
      __typename
    }
    memories
    sessionUID
    userPreBrief
    chatSessionId
    aiSuggestions
    insights {
      id
      label
      type
      content
      items {
        label
        content
        category
        completed
        items
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateProxyMeetingMutationVariables, APITypes.UpdateProxyMeetingMutation>

export const updateCalendarEventWithPreBrief = /* GraphQL */ `mutation UpdateCalendarEventWithPreBrief(
  $input: UpdateCalendarEventInput!
  $condition: ModelCalendarEventConditionInput
) {
  updateCalendarEvent(input: $input, condition: $condition) {
    id
    uuid
    calendarId
    userProfileId
    platform
    proxyMeetingId
    dateUtc
    projectIds
    recurringId
    iCalUid
    title
    startTimeUtc
    endTimeUtc
    isCancelled
    shortDescription
    meetingUrl
    organizerEmail
    fullDescription
    responseStatus
    status
    descriptionContentType
    attendees
    platformSpecificData
    metadata
    preBrief {
      id
      label
      type
      content
      items {
        label
        content
        category
        completed
        items
      }
    }
    botStatus {
      statusCode
      subCode
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateCalendarEventMutationVariables, APITypes.UpdateCalendarEventMutation>

export const userProfilesWithPreferencesByAuthProviderUserId =
  /* GraphQL */ `query UserProfilesWithPreferencesByAuthProviderUserId(
  $authProviderUserId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  userProfilesByAuthProviderUserId(
    authProviderUserId: $authProviderUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      name
      image
      authProviderUserId
      preferences
      createdAt
      updatedAt
      deactivatedAt
      onboardingState
      is_subscribed
      credits
      credits_quota
      meeting_hours
      meeting_hours_quota
      scheduled_hours
      timezone
      language
      autoScheduleProxy
      preBrief
      notifications {
        preBrief
        pmfSummary
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.UserProfilesByAuthProviderUserIdQueryVariables,
    APITypes.UserProfilesByAuthProviderUserIdQuery
  >

export type GetConceptWithEntriesQuery = APITypes.GetConceptQuery & {
  getConcept?: (APITypes.Concept & { entries?: { items: APITypes.ConceptEntry[] | null } }) | null
}

export const getConceptWithEntries = /* GraphQL */ `query GetConceptWithEntries($id: ID!, $userProfileId: ID!) {
    getConcept(id: $id, userProfileId: $userProfileId) {
      id
      userProfileId
      title
      type
      entries {
        items {
          id
          body
          createdAt
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
  ` as GeneratedQuery<APITypes.GetConceptQueryVariables, GetConceptWithEntriesQuery>
